"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuessAnswerEventDTO = void 0;
const enums_1 = require("../enums");
class GuessAnswerEventDTO {
    // the id of the answer that was guessed
    constructor(payload) {
        this.name = enums_1.Level1EventName.GUESS_ANSWER;
        this.payload = payload;
    }
}
exports.GuessAnswerEventDTO = GuessAnswerEventDTO;
//# sourceMappingURL=GuessAnswerEventDTO.js.map